<div class="clsCardModal">
  <div class="modal-body break-word">
    <div class="title">
      {{ 'component.leftNavBar.help-modal.title' | translate }}
    </div>

    <div class="subtitle">
      {{ 'component.leftNavBar.help-modal.subtitle' | translate }}
    </div>

    <div class="section" [innerHTML]="vivaEngageMessage"></div>

    <div class="subtitle">
      {{ 'component.leftNavBar.help-modal.viva-engage-info' | translate }}
    </div>

    <div
      class="section"
      [innerHTML]="
        'component.leftNavBar.help-modal.knowledge-base-section' | translate
      "
    ></div>

    <div class="subtitle">
      {{ 'component.leftNavBar.help-modal.knowledge-base-info' | translate }}
    </div>

    <div class="section" [innerHTML]="otherRequestsMessage"></div>

    <div class="subtitle">
      {{ 'component.leftNavBar.help-modal.other-requests-info' | translate }}
    </div>

    <div class="section" [innerHTML]="provideProductSuggestionMessage"></div>

    <div class="subtitle">
      {{
        'component.leftNavBar.help-modal.provide-product-suggestion-info'
          | translate
      }}
    </div>

    <div class="section" [innerHTML]="openIncidentMessage"></div>

    <div class="subtitle">
      {{ 'component.leftNavBar.help-modal.open-incident-info' | translate }}
    </div>

    <div class="clsFooterRow">
      <button class="clsFooterButton" (click)="onCloseDialog()">
        {{ 'common.close' | translate }}
      </button>
    </div>
  </div>
</div>
